import type { ComponentPropsWithoutRef } from "react";

type ToggleProps = Omit<ComponentPropsWithoutRef<"input">, "type">;

export function Toggle(props: ToggleProps) {
  return <input {...props} type="checkbox" role="switch" />;
}
